export default __webpack_public_path__ + "4048450268bbc139eb5886996a1b3291.png";